"use client"

import { useTr } from "../../lib/use-tr"
import type { ReactNode } from "react"

import {
  LEAD_CATEGORY_META,
  LEAD_CATEGORY_T,
} from "@/lib/apps/autoleads/lead-category"
import { cn } from "@/lib/utils"

import { Badge } from "@/components/ui/badge"

import type { LeadCategory } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

export function CategoryBadge({
  category,
  className,
  children,
}: {
  category: LeadCategory
  className?: string
  // Trails the label inside the pill, e.g. the ellipsis of a menu action.
  children?: ReactNode
}) {
  const tr = useTr(LEAD_CATEGORY_T)
  const meta = LEAD_CATEGORY_META[category]
  return (
    <Badge
      variant={meta.variant}
      tone={meta.tone}
      className={cn("font-normal", className)}
    >
      <meta.Icon className={meta.iconClassName} />
      {tr(meta.labelKey)}
      {children}
    </Badge>
  )
}
